<template>
  <div class="list-modal-done h-card shadow">
    <div class="card-header">
      <div class="modal-title"></div>
      <button type="button" @click="closeCmodal" class="btn-close" data-bs-dismiss="modal"
              aria-label="Закрыть"></button>
    </div>
    <div class="card-body">
      <div class="p-3 small">
        <h5>Текст скопирован - можете переслать клиенту!</h5>
      </div>
    </div>
    <div class="card-footer">
      <button class="close-btn" @click="closeCmodal">Закрыть</button>

    </div>

  </div>
</template>
<script>
import {popModal} from "jenesius-vue-modal";


export default {
  name: 'SendListDone',
  methods: {
    closeCmodal() {
      popModal();
    },
  }
}
</script>
<style scoped>


.list-modal-done {
  width: 460px;
  //max-height: 100vh;
  container-name: list-modal-container;
  container-type: inline-size;
}

.list-modal-donel .card-body {
  padding: 0;
  overflow: auto;
  height: 400px;
  max-height: 95vh;
}

@container list-modal-container {
  .list-modal-done .card-body {
    height: 80cqh;
  }
}

</style>